import type { FrontendErrorRecord } from './frontend-error.model';

export const FRONTEND_ERROR_STORAGE_KEY = 'nt25.frontend.errors';
const DEFAULT_MAX_ENTRIES = 50;

function getSessionStorage(): Storage | null {
  try {
    return globalThis.sessionStorage ?? null;
  } catch {
    return null;
  }
}

export class FrontendErrorStore {
  private entries: FrontendErrorRecord[];

  constructor(
    private readonly storage: Storage | null = getSessionStorage(),
    private readonly maxEntries = DEFAULT_MAX_ENTRIES
  ) {
    this.entries = this.readEntries().slice(0, this.maxEntries);
    this.persist();
  }

  getEntries(): FrontendErrorRecord[] {
    return [...this.entries];
  }

  add(entry: FrontendErrorRecord): FrontendErrorRecord[] {
    this.entries = [entry, ...this.entries].slice(0, this.maxEntries);
    this.persist();
    return this.getEntries();
  }

  clear(): void {
    this.entries = [];
    this.persist();
  }

  private readEntries(): FrontendErrorRecord[] {
    if (!this.storage) {
      return [];
    }

    try {
      const rawValue = this.storage.getItem(FRONTEND_ERROR_STORAGE_KEY);

      if (!rawValue) {
        return [];
      }

      const parsed = JSON.parse(rawValue);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  private persist(): void {
    if (!this.storage) {
      return;
    }

    try {
      this.storage.setItem(FRONTEND_ERROR_STORAGE_KEY, JSON.stringify(this.entries));
    } catch {
      // Ignore storage quota and serialization failures.
    }
  }
}
